import KitButton from '@omni/kit/components/KitButton';
import { IconName } from '@omni/kit/components/KitIcon';
import KitText from '@omni/kit/components/KitText';
import Colors from '@omni/kit/theming/Colors';
import Spacing from '@omni/kit/theming/Spacing';
import { useThemeContext } from '@omni/kit/theming/ThemeContext';
import React, { ReactElement } from 'react';
import { Pressable, View, ViewStyle } from 'react-native';

const ICON_BUTTON_SIZE = 44;
const BUTTON_TEXT_WIDTH = 100; // Ensure text is not wrapped

interface ButtonIconTextProps {
  icon: IconName;
  iconBackgroundColor?: string;
  iconColor?: string;
  onLayout?: (event: any) => void;
  onPress?: () => void;
  style?: ViewStyle;
  text?: string;
  isLoading?: boolean;
}

export default ({
  icon,
  iconBackgroundColor,
  iconColor,
  onLayout,
  onPress,
  style = {},
  text,
  isLoading = false,
}: ButtonIconTextProps): ReactElement => {
  const { colorForScheme } = useThemeContext();

  return (
    <Pressable
      style={{
        alignItems: 'center',
        display: 'flex',
        ...style,
      }}
      onPress={onPress}
    >
      <View onLayout={onLayout}>
        <KitButton
          secondary
          circle
          height={ICON_BUTTON_SIZE}
          icon={icon}
          color={
            iconBackgroundColor ||
            colorForScheme?.({
              light: Colors.N100,
              dark: Colors.N900,
            }) ||
            Colors.N100
          }
          iconColor={
            iconColor ||
            colorForScheme?.({
              light: Colors.N900,
              dark: Colors.N0,
            }) ||
            Colors.N900
          }
          paddingLeft={0}
          paddingRight={0}
          onPress={onPress}
          isLoading={isLoading}
          underlayColor={colorForScheme?.({
            light: Colors.N100,
            dark: Colors.N900,
          })}
        />
      </View>
      {text ? (
        <KitText
          color={
            colorForScheme?.({
              light: Colors.N900,
              dark: Colors.N0,
            }) || Colors.N900
          }
          style={{
            marginTop: Spacing.m,
            textAlign: 'center',
            width: BUTTON_TEXT_WIDTH,
          }}
        >
          {text}
        </KitText>
      ) : null}
    </Pressable>
  );
};
